import React from 'react';
import Spinner from './Spinner';
import './ui.css';

export const AdminLoadingState: React.FC<{ label?: string }> = ({ label = 'Carregando...' }) => (
  <div className="admin-loading">
    <Spinner />
    {label}
  </div>
);

export const AdminEmptyState: React.FC<{ message: string }> = ({ message }) => (
  <div className="admin-empty">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <line x1="3" y1="9" x2="21" y2="9" />
      <line x1="8" y1="14" x2="16" y2="14" />
    </svg>
    <p>{message}</p>
  </div>
);
